<template lang="pug">
	div
		div(class="resume-wide resume-vertical-scroll" style="border:none;")
			div(@click="m_editMode")
				div(class="section-title")
					<strong class="primary">💼Experience</strong><sup title="Toggle Edit" variant="outline-primary" style="border:none;"><fa-icon icon="pencil-alt" /></sup>
			div(v-if="d_editMode")
				kt-spinner(v-if="d_loading" p_txt="positions")
				b-table(id="positions" :fields="d_positionFields" :items="d_positions" class="font-weight-bold" style="font-size: 12px;" sticky-header="2000px"
					small striped responsive borderless hover selectable 	select-mode="single" 	selected-variant="success" 	show-empty 	tbody-tr-class="rowStyle" 
					@row-clicked="m_clicked" @row-dblclicked="m_dblClicked" table-class="table-fixed"
					)
					<template v-slot:cell(position)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.position }}</div>
						<b-form-input v-else v-model="data.item.position"   size="sm"  />
					</template>
					<template v-slot:cell(company)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.company}}</div>
						<b-form-input v-else v-model="data.item.company"   size="sm"  />
					</template>
					<template v-slot:cell(startDate)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.startDate }}</div>
						<input v-else type="date" v-model="data.item.startDate" />
					</template>
					<template v-slot:cell(endDate)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.endDate }}</div>
						<input v-else type="date" v-model="data.item.endDate" />
					</template>
					<template id="experience" v-slot:cell(experience)="data">
								<div v-if="d_selectedIndex !== data.index">{{ data.item.experience}}</div>
								<b-form-textarea v-else v-model="data.item.experience"   size="sm"   />
					</template>
					template(#empty="scope")
						span No Professional experience!!
				div(v-if="d_copyPaste")
					<vue-editor ref="editor" v-model="d_copyPasteData" :editorToolbar="d_editorModules" @ready="m_onEditorReady" :placeholder="d_placeholder"></vue-editor>
			div(v-else)
				div(v-if="d_positions.length>0")
					div(v-for="p in d_positions" :key="p.position")
						<span v-html="m_getPosition(p)" style="color:black;"></span>
				span(v-else) No Professional Experience!!
			
			
</template>
<script>
import {fn_callAI} from "@/utils/api.js";
import {kbdpAlert} from "@/utils/util.js";
import {VueEditor} from "vue2-editor";
export default {
  name: "resumePositions",
  components: {VueEditor},
  data() {
    return {
		d_positionFields:[{key:"position",field:"position",title:"Position",type:"input", datatype:"text",required:true},
						{key:"company",field:"company",title:"Company",type:"input", datatype:"text",required:true},
						{key:"startDate",field:"startDate",title:"From",type:"input", datatype:"date", required:true},
						{key:"endDate",field:"endDate",title:"To",type:"input", datatype:"date",required:true},
						{key:"experience",field:"experience",title:"Experience",type:"textarea", datatype:"text",required:true,thStyle: { width: "400px" },tdStyle: { width: "400px"}

},
						],
		d_cardSchema:null,
		d_selectedRecord:null,
		d_selectedIndex:null,
		d_deleteEnabled:null,
		d_editMode:this.p_editMode,
		d_positions: [],
		d_newRecord:{position:null,company:null,startDate:null, endDate:null,experience:null },
		d_copyPaste:false,
		d_copyPasteData:"",
		d_editorModules: [
						['bold', 'italic', 'underline'],
                        [{  color: []}, { background: []}],
						[{ 'list': 'ordered' }, { 'list': 'bullet' }],
						['clean'],['upload']   // 👈 your custom button
						],
		d_quill:null,
        d_placeholder:"Format, Position, Company, Start Date ,End Date:Experience",
		d_loading:null,

    };
  },
created() {this.d_positions = (this.value || []).map(row => ({ ...row }));},
mounted(){},
props: {
		value: Array,
		p_editMode:Boolean,
},
computed: {},
methods: {
m_editMode() {
  this.d_editMode = !this.d_editMode;
  if(this.d_editMode) this.$emit("activate", "positions");
  if(!this.d_editMode) this.d_copyPaste=false;
},
m_copyPaste(){this.d_copyPaste=!this.d_copyPaste;},
m_getPosition(data){
	if(!data.position) return"";
	return `<p><strong style="color:blue;">${data.position}, ${data.company}</strong> ${data.startDate} - ${data.endDate}<br /><span style="color:black;">${data.experience}</span></p>`;
},
m_addRecord() {
	//const recordId = Date.now() + Math.random();
	this.d_positions.push(JSON.parse(JSON.stringify(this.d_newRecord)));

  // Open modal for editing
  this.d_editMode = true;
  this.d_selectedIndex=this.d_positions.length-1;
},
m_clicked(row,index) {
    this.d_selectedIndex = index;	
},
m_dblClicked(table, row) {
	if (!this.d_selectedIndex) return;
    this.d_editMode = true;
},

m_save(){
	this.$emit("input", this.d_positions);
},

m_undo(){
	this.d_positions.length=0;
	this.d_positions = (this.value || []).map(row => ({ ...row }))
},
m_deleteRecord(){
	let temp = [...this.d_positions];
	temp.splice(this.d_selectedIndex, 1);
	this.d_positions = this.temp.map(row => ({ ...row }));
},
m_processCopyPaste(){

function bulletsToParagraphs(bullets) {
  if (!Array.isArray(bullets) || bullets.length === 0) return "";

  const paragraphs = [];
  let currentSentence = "";
  let currentParagraph = [];

  const isFragment = (text) => {
    return (
      /^[a-z]/.test(text) ||                // starts lowercase
      /^(to |with |and |or |based on )/i.test(text) ||
      !/[.!?]$/.test(text)                  // no sentence-ending punctuation
    );
  };

  const flushSentence = () => {
    if (currentSentence.trim()) {
      currentParagraph.push(currentSentence.trim());
      currentSentence = "";
    }
  };

  const flushParagraph = () => {
    flushSentence();
    if (currentParagraph.length > 0) {
      paragraphs.push("<p>"+currentParagraph.join(" ")+"</p>");
      currentParagraph = [];
    }
  };

  for (const raw of bullets) {
    const bullet = raw.trim();

    if (!currentSentence) {
      currentSentence = bullet;
      continue;
    }

    if (isFragment(bullet)) {
      // Append fragment to current sentence
      currentSentence += " " + bullet.replace(/^[A-Z]/, m => m.toLowerCase());
    } else {
      // Finish previous sentence and start a new one
      flushSentence();
      currentSentence = bullet;
    }

    // Heuristic: limit paragraph length
    if (currentParagraph.length >= 4) {
      flushParagraph();
    }
  }

  flushParagraph();

  return paragraphs.join("\n\n");
}

const text = this.quill.getText();






console.log('About calling chatGPT');
let promptText = `Kindly extract all positions, companies, start dates, end dates, and experience details from the following resume text:

${text}

Return a JSON array of objects with the properties: position, company, startDate, endDate, and experience.`;

this.d_loading=true;
fn_callAI(promptText)
  .then(resp => {
				resp.forEach(p=>{
				var {position,company,startDate,endDate,experience}=p;
				var newRecord={position:position,company:company,startDate:startDate,endDate:endDate,experience:bulletsToParagraphs(experience)};
				this.d_positions.push(newRecord);
				});
				this.d_loading=false;
				})
  .catch(err => {
				console.error(err)
				this.d_loading=false;
				kbdpAlert.showErr("Network Error: Please try again!!");
				
				});


},
m_onEditorReady(editorInstance) {

    this.quill = editorInstance;

    // Find the toolbar DOM element
    const toolbarEl = this.quill.container.parentNode.querySelector('.ql-toolbar');

    if (toolbarEl) {
      // Create your custom button container
		const customBtn = document.createElement('button');
		customBtn.className = 'ql-custom-upload';
		customBtn.title = "Upload";
		customBtn.appendChild(document.createTextNode("📤"));

      // Attach click handler
      customBtn.addEventListener('click', this.m_processCopyPaste);

      // Inject into toolbar
      toolbarEl.appendChild(customBtn);
    }
  },
},
watch: {
 p_editMode(newVal) {
    this.d_editMode = newVal;
  },
value: {
  immediate: true,
  deep: true,
  handler(newVal) {
    if (!newVal) return;
	this.d_resumeData = newVal.resumeData;
    this.d_positions = newVal.map(row => ({ ...row }))
  }
 },

 }
}
</script>
<style scoped>
.cv-container {
  max-width: 900px;
  margin: auto;
}
section {
  margin-bottom: 2rem;
}
.section-header {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
}

.timeline {
  position: relative;
  list-style: none;
  padding-left: 30px;
  margin-top: 1rem;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #ddd;
}

.timeline-item {
  position: relative;
  margin-bottom: 2rem;
  cursor: grab;
}

.dot {
  position: absolute;
  left: 4px;
  top: 18px;
  width: 16px;
  height: 16px;
  background: #2c7be5;
  border-radius: 50%;
}

.card {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 1rem;
  margin-left: 20px;
}

input,
textarea {
  width: 100%;
  margin-bottom: 0.5rem;
}

.row {
  display: flex;
  gap: 0.5rem;
}

button {
  cursor: pointer;
}

.debug {
  background: #f7f7f7;
  padding: 1rem;
  font-size: 0.8rem;
}
.header-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}
.header-btn .emoji {
  font-size: 1.2rem;
  cursor: pointer;
}
.emoji {
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.emoji:hover {
  background: #f0f0f0;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒";     /* "🡒" */
  color: #1E90FF; 
}
details[open] summary::before { 
  content:"🠣";  /* "🠣""🡑"*/ 
  color: #1E90FF; 
}
.btn-add {
	text-align: right;
	border:none;
	}
.btn-delete {
	color: #dc3545;
	text-align: right;
	border:none;
	}
.btn-add {
	color: #4fa4ff;
	border:none;
	}
.btn-expand {
	color: #FFA500;
	border:none;
	}
.resume-wide {
  width: 100%;
  min-width: 1200px; /* or whatever your tables need */
  position: relative;
  z-index: 10;
  overflow-x: auto;
  overflow-y: auto;
}
.col-4 {
  overflow: visible !important;
}
.resume-flex-expand {
  flex: 1 1 100%;
  max-width: 100%;
}
.resume-wide textarea {
  border: 1px solid #ccc;
  padding: 12px;
  font-size: 14px;
  line-height: 1.4;
}
.resume-vertical-scroll {
  max-height: 4000px;   /* adjust to your needs */
  overflow-y: auto;
  overflow-x: hidden;  /* optional, keeps it tidy */
  border: none;
  border-radius: 4px;
  background: #fff;
}
table td {
  overflow: visible !important;
}
.section-title {
    font-size: 15px;
    font-weight: 700;
    text-transform1: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 4px;
    margin-bottom: 12px;
  }
td.experience1 {
  width: 40%;
}
.table-fixed {
table-layout: fixed;
}
</style>

/*
var pastedRows = text
  .split(/\r?\n/)
  .map(line => line.trim())
  .filter(line => line.length)
  .map(line => {
    // Split by commas NOT inside quotes
    return line.match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g)
      .map(field => {
        // Remove surrounding quotes if present
        field = field.trim();
        if (field.startsWith('"') && field.endsWith('"')) {
          field = field.slice(1, -1);
        }
        return field;
      });
  });

function bulletsToParagraphs(bullets, maxBulletsPerParagraph = 5) {
  if (!Array.isArray(bullets) || bullets.length === 0) return "";

  const paragraphs = [];
  for (let i = 0; i < bullets.length; i += maxBulletsPerParagraph) {
    const chunk = bullets.slice(i, i + maxBulletsPerParagraph)
      .map(s => s.trim())
      .join(" "); // join bullets with space for narrative
    paragraphs.push(chunk);
  }

  return paragraphs.join("\n\n"); // double newline for paragraph separation
}
<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>Resume</title>
<style>
  /* --- Page Layout --- */
  body {
    font-family: "Inter", Arial, sans-serif;
    font-size: 14px;
    line-height: 1.45;
    color: #222;
    background: #f5f5f5;
    padding: 40px 0;
  }

  .resume-page {
    max-width: 800px;
    margin: 0 auto;
    background: #fff;
    padding: 40px 50px;
    border: 1px solid #ddd;
    box-shadow: 0 0 4px rgba(0,0,0,0.1);
  }

  /* --- Header --- */
  .header {
    text-align: center;
    margin-bottom: 30px;
  }
  .header h1 {
    font-size: 28px;
    margin-bottom: 4px;
  }
  .header .subtitle {
    font-size: 15px;
    color: #555;
  }
  .contact {
    margin-top: 10px;
    font-size: 13px;
    color: #444;
  }

  /* --- Section Titles --- */
  .section {
    margin-bottom: 28px;
  }
  .section-title {
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 4px;
    margin-bottom: 12px;
  }

  /* --- Experience Rows --- */
  .experience-row {
    margin-bottom: 16px;
  }
  .experience-header {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
  }
  .experience-header .role {
    font-size: 14px;
  }
  .experience-header .dates {
    font-size: 13px;
    color: #666;
  }
  .company {
    font-size: 13px;
    color: #444;
    margin-bottom: 6px;
  }
  .experience-row ul {
    margin: 0 0 0 20px;
    padding: 0;
  }
  .experience-row li {
    margin-bottom: 4px;
  }

  /* --- Education --- */
  .edu-row {
    margin-bottom: 12px;
  }
  .edu-row .degree {
    font-weight: 600;
  }
  .edu-row .school {
    color: #444;
  }
  .edu-row .dates {
    color: #666;
    font-size: 13px;
  }

  /* --- Skills --- */
  .skills-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
  }
  .skills-list span {
    background: #eee;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 13px;
  }

  /* --- Print Styles --- */
  @media print {
    body {
      background: white;
      padding: 0;
      -webkit-print-color-adjust: exact;
    }
    .resume-page {
      box-shadow: none;
      border: none;
      padding: 0;
    }
  }
</style>
</head>

<body>
<div class="resume-page">

  <!-- Header -->
  <div class="header">
    <h1>John Doe</h1>
    <div class="subtitle">Senior Software Engineer</div>
    <div class="contact">
      john.doe@email.com • (555) 123‑4567 • Toronto, ON
    </div>
  </div>

  <!-- Experience -->
  <div class="section">
    <div class="section-title">Experience</div>

    <div class="experience-row">
      <div class="experience-header">
        <div class="role">Senior Software Engineer</div>
        <div class="dates">2020 – Present</div>
      </div>
      <div class="company">Microsoft</div>
      <ul>
        <li>Designed and built scalable cloud services using Node.js and Azure.</li>
        <li>Led a team of 6 engineers delivering enterprise‑grade integrations.</li>
        <li>Improved system performance by 40% through architectural refactoring.</li>
      </ul>
    </div>

    <div class="experience-row">
      <div class="experience-header">
        <div class="role">Full‑Stack Developer</div>
        <div class="dates">2017 – 2020</div>
      </div>
      <div class="company">Shopify</div>
      <ul>
        <li>Developed customer‑facing features using React and Ruby on Rails.</li>
        <li>Collaborated with designers to improve UX and accessibility.</li>
      </ul>
    </div>
  </div>

  <!-- Education -->
  <div class="section">
    <div class="section-title">Education</div>

    <div class="edu-row">
      <div class="degree">B.Sc. Computer Science</div>
      <div class="school">University of Toronto</div>
      <div class="dates">2013 – 2017</div>
    </div>
  </div>

  <!-- Skills -->
  <div class="section">
    <div class="section-title">Skills</div>
    <div class="skills-list">
      <span>JavaScript</span>
      <span>Node.js</span>
      <span>React</span>
      <span>Vue</span>
      <span>SQL</span>
      <span>Cloud Architecture</span>
      <span>CI/CD</span>
    </div>
  </div>

</div>
</body>
</html>


*/
